const dailyApi = require('../api/dailyQuests');

const MIN_INTERVAL_UPDATE = 1000 * 60 * 5; // 5 minutes
const FETCH_INTERVAL_TIMEOUT = 1000 * 30; // 30 seconds

function fetchIntervalInProgress(fetchPromise) {
  return {
    type: 'FETCH_DAILY_BOOST_INTERVAL_IN_PROGRESS',
    timestamp: Date.now(),
    fetchPromise,
  };
}

function fetchIntervalSuccessful(interval) {
  return {
    type: 'FETCH_DAILY_BOOST_INTERVAL_SUCCESSFUL',
    interval,
    timestamp: Date.now(),
  };
}

function fetchIntervalFailed(reason) {
  return {
    type: 'FETCH_DAILY_BOOST_INTERVAL_FAILED',
    reason,
    timestamp: Date.now(),
  };
}

function fetchIntervalQuests() {
  return (dispatch, getState) => {
    const {
      auth: { apiUrl },
    } = getState();

    if (!apiUrl) {
      return Promise.resolve();
    }

    const fetchPromise = dailyApi
      .fetchCurrentInterval(apiUrl)
      .then((interval) => {
        dispatch(fetchIntervalSuccessful(interval));
        return interval;
      })
      .catch((error) => {
        dispatch(fetchIntervalFailed(error));
        throw error;
      });

    dispatch(fetchIntervalInProgress(fetchPromise));

    return fetchPromise;
  };
}

function shouldFetchInterval(state, skipOutdatedCheck) {
  const { fetchingInProgressSince, didInvalidate, lastSuccessfulFetch } =
    state.dailyBoostInterval;

  if (!fetchingInProgressSince) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    if (
      new Date(lastSuccessfulFetch).getUTCDate() !== new Date().getUTCDate()
    ) {
      return true;
    }

    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_INTERVAL_UPDATE)
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_INTERVAL_TIMEOUT
  ) {
    // Ensure we cannot get stuck in fetchingInProgressSince=true state.
    return true;
  }

  return false;
}

function fetchIntervalQuestIfNeeded() {
  return async (dispatch, getState) => {
    if (shouldFetchInterval(getState())) {
      return dispatch(fetchIntervalQuests());
    }
    const {
      dailyBoostInterval: { interval, fetchPromise },
    } = getState();
    return fetchPromise && fetchPromise.then ? fetchPromise : interval;
  };
}

function setShowPopup() {
  return (dispatch) => {
    dispatch({ type: 'FORCE_SHOWING_POPUP_AFTER_LOGIN' });
  };
}

function setPopupShown() {
  return (dispatch) => {
    dispatch({ type: 'SHOWN_POPUP_AFTER_FORCING' });
  };
}

function setNotificationsDisabled() {
  return (dispatch) => {
    dispatch({ type: 'DISABLE_NOTIFICATIONS' });
  };
}

function setNotificationsEnabled() {
  return (dispatch) => {
    dispatch({ type: 'ENABLE_NOTIFICATIONS' });
  };
}

module.exports = {
  fetchIntervalQuests,
  fetchIntervalQuestIfNeeded,
  setShowPopup,
  setPopupShown,
  setNotificationsDisabled,
  setNotificationsEnabled,
};
